export default __webpack_public_path__ + "static/media/heart-waiting.9e1318af.svg";